angular.module('unica_hotel.hotel_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// HOTEL LIST AND DELETE
		.state('app.hospitality.hotel_list', {
			url: '/hotel-list',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/hotel/templates/list.html',
					controller: 'HotelListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Hotels',
				parent: 'app.hospitality.dashboard'
			}
		})

		// HOTEL CREATE
		.state('app.hospitality.hotel_create', {
			url: '/hotel-create',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/hotel/templates/create.html',
					controller: 'HotelCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Aggiungi Hotel',
				parent: 'app.hospitality.hotel_list'
			}
		})

		// HOTEL EDIT
		.state('app.hospitality.hotel_edit', {
			url: '/hotel-edit/:id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/hotel/templates/edit.html',
					controller: 'HotelEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Hotel',
				parent: 'app.hospitality.hotel_list'
			}
		});




});

